import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { MasterscreenService } from 'src/app/masterscreen/services/masterscreen.service';
import { ConstantsService } from 'src/app/shared/services/constants.service';
import { Login } from '../../../observation/model/login.model';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { User, UserLogInActivity, UserLogInActivityDetails, UserPermissionParameters } from "../../../shared/models/user.model";

import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { HseErrorHandlerService } from '../../../shared/services/hse-error-handler.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { TNCApprovals } from '../../model/TNCApprovals.model';
import { TNCParticular } from '../../model/TnCParticular.model';
import { TNCPermission } from '../../model/TNCPermission.model';
import { TNCRequest } from '../../model/TNCRequest.model';
import { TNCRequestPost } from '../../model/TNCRequestPost.model';
import { CourseStatus, TncConstantsService, TrainingsStatus } from '../../services/tnc-constants.service';
import { TrainingAndCompetencyService } from '../../services/training-and-competency.service';
import { ObservationConstantsService } from "../../../observation/services/observation-constants.service";

@Component({
  selector: 'ara-assign-training',
  templateUrl: './assign-training.component.html',
  styleUrls: ['./assign-training.component.css']
})
export class AssignTrainingComponent implements OnInit {

  ParticularDataSub: Subscription;
  ConfigurationDataSub: Subscription;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  userResults: User[] = [];
  isCourseDetailsValid: boolean = false;
  isStatusDetailsValid: boolean = false;
  invalidCertificate: boolean = false;
  TrainingCertificateFiles: any[] = [];
  particularResults: TNCParticular[] = [];
  searchTexts: SearchText;
  TNCForm: FormGroup;
  employee: any[] = [];
  TNCRequest: TNCRequest;
  login: Login;
  isUpdate: boolean = false;
  display: boolean = true;
  loggedInUserJSON: any;
  courseTitle: SelectItem[] = [];
  coursePriority: SelectItem[] = [];
  courseSpecification: SelectItem[] = [];
  courseMode: SelectItem[] = [];
  courseMedium: SelectItem[] = [];
  data: SelectItem[] = [];
  validity: string;
  user: any;
  nameRS: string;
  designationRS: string;
  namePS: string;
  designationPS: string;
  designationExtension: string;
  nameExtension: string;
  sub: any;
  courseId: number = 0;
  unitId: number = 0;
  UserId: number = 0;
  assignedBy: any;
  tncRequest: any;
  tillToDateForDuration = new Date();
  priorityId: number = 0;
  specificationId: number = 0;
  trainingStatus: number;
  tncPermissions: TNCPermission = new TNCPermission();
  courseStatus: number;
  SelectedTrainee: any;
  allUsersData: SelectItem[] = [];
  allUsers: any;
  traineeName: any;
  designation: any;
  currentFileUrl: string;
  isManager: boolean = false;
  isTrainee: boolean = false;
  dialogType: string;
  alertType: string;
  successDetails: any;
  errorDetails: any;
  confirmMessage: string;
  CourseStatus = CourseStatus;
  TrainingsStatus = TrainingsStatus;
  statusName: any;
  courseIndex: number;
  isNext: boolean = true;
  disableCourse: boolean;
  courseIds: any;
  isPrevious: boolean = true;
  userPermissions: UserPermissionParameters = new UserPermissionParameters();
  isStatusModified: boolean = false;
  permissions: TNCPermission = new TNCPermission();
  disableTNC: boolean;
  moduleList: any;
  moduleId: any;
  UserTypeIDName: string = "Employee ID:";
  reporties: number[] = [];
  independentPermissions: any;
  PreviewUrl: string = "";
  FileName: string = "";
  displayFile: boolean = false;
  accept: string = ".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS";
  filesPreview: any[] = [];
  maxExpiryDate: Date;
  validator: string;
  validatorDesignation: string;
  ApprovalDate: Date;
  status: string;
  isApprovalSectionShow: boolean;
  immediateSuperwiser: User = new User();
  isCertificateRequired: boolean = false;
  updateActionTrack: any[];
  userActivityList: UserLogInActivity[] = [];
  userActivityListForTrainingStatus: UserLogInActivity[] = [];
  userActivityListForApproval: UserLogInActivity[] = [];
  updateSourceActionData: any;
  oldTNCTrainingStatus : any;
  isNew: boolean = false;
  retVal: boolean;
  unitData : any;
  url: any;
  url1: any;
  title : any;
   //BOC Pritesh
   dialogHeight: string;
   dialogWidth: string;
   ReportUserId : number;
   ReportModule : string;
   ReportRecordId : number;
   ReportProcessId : number = 0;
   ReportclosePopup: boolean = false;
   count : number = 0;
   countValidity : number = 0;
   //EOC Pritesh
   isTrainingDuplicated: boolean = false;
  constructor(private commonService: CommonService, private hseErrorHandler: HseErrorHandlerService,
    private formBuilder: FormBuilder, private baseService: BaseService, private translate: TranslateService, private TnCService: TrainingAndCompetencyService,
    private masterscreenService: MasterscreenService, private notificationsService: NotificationsService, private route: ActivatedRoute, private router: Router) {
    this.routesFlag = TncConstantsService.TNCNavigation.InnerRoutes;
    this.reportRoutes = TncConstantsService.TNCNavigation.ReportRoutes;

    this.searchTexts = new SearchText();
    this.baseService.translatorListener.subscribe((data) => {
      this.TNCRequest.TNCRequest = new TNCRequestPost();
      this.translate.use(data);
      this.login = new Login();
    });

    this.data = [{ label: 'Data 1', value: '1' },
    { label: 'Data 2', value: '2' },
    { label: 'Data 3', value: '3' },];
  }
  
  setPriority(event) {
    this.priorityId = event.value;
    this.courseTitle = [];
    this.TNCForm.patchValue({ Title: '' });
    this.validity = null;
    this.getParticularInfo();
  }

  setSpecification(event) {
    this.specificationId = event.value;
    this.courseTitle = [];
    this.TNCForm.patchValue({ Title: '' });
    this.validity = null;
    this.getParticularInfo();
  }
  
  getUsersOnSearch(event) {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));

  }
 
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      let filtered: any[] = [];
      if (this.reporties.length) {
        for (let i = 0; i < response.Result.length; i++) {
          this.user = response.Result[i];
          if (
            this.user.FullName.toLowerCase().indexOf(
              this.searchTexts.FilterTexts.toLowerCase()
            ) !== -1
          ) {
            filtered.push(this.user);
          }
        }
        //response.Result = response.Result.filter(u => this.reporties.includes(u.UserId));
      }

      if (this.permissions.TNC_Admin || this.permissions.TNC_Admin_Unit) {
        response.Result.push(this.loggedInUserJSON);
      }
      for (let i = 0; i < response.Result.length; i++) {
        const user = response.Result[i];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      // Remove duplicate users by UserId
      const uniqueUsers = new Map();
      filtered.forEach(user => {
        if (!uniqueUsers.has(user.UserId)) {
          uniqueUsers.set(user.UserId, user);
        }
      });
      this.userResults = Array.from(uniqueUsers.values());
    }

    if (response.Errors !== null) {
      this.hseErrorHandler.handleError(response.Errors);
    }
  }
  
  isEmployee:boolean=true;
  selectUser(event) {
    if (event.UserId) {
      if (event.UserTypeId == 2) {
        this.UserTypeIDName = "Contractor ID:";
        this.isEmployee=false;
      }
      else if (event.UserTypeId == 1) {
        this.UserTypeIDName = "Employee ID:";
        this.isEmployee=true;
      }
      this.TNCForm.patchValue({ TraineeName: event });
      this.TNCForm.patchValue({ Designation: event.Designation ? event.Designation : '' });
      this.TNCForm.patchValue({ ContractNumber: event.ContractNumber ? event.ContractNumber : '' });
      this.TNCForm.patchValue({ EmployeeId: event.SecondaryId });
      this.TNCForm.patchValue({ ImmediateSupervisor: event.ReportingTo ? this.allUsers.find(u => u.UserId == event.ReportingTo).FullName : '' });
      this.TNCForm.patchValue({ BaseUnit: event.UnitName ? event.UnitName : '' });
    }
  }

  getOtherParticularDetails(event) {
    const id = event.value;
    this.validity = this.particularResults.find(s => s.ParticularId == id).Validity;
    //this.TNCForm.patchValue({Validity : this.particularResults.find(s=>s.ParticularId==id).Validity});
    if(this.validity != 'Lifetime')
    {
      if(this.validity != "As per certificate")
      {
      if(this.TNCForm.get("CompletionDate").value != "" )
      {
        let CompDate = new Date(this.TNCForm.get("CompletionDate").value);
        this.TNCForm.patchValue({
          ExpiryDate: moment(moment.utc(new Date(CompDate.setFullYear(CompDate.getFullYear() + parseInt(this.validity)))).local()).toDate() 
        });
      }
      }
      else
      {
        this.TNCForm.patchValue({ ExpiryDate: '' });
      }
    }
  }

  serviceError() {
    this.hseErrorHandler.handleError(
      "Service (WebAPI) is not available or not in running mode"
    );
  }

  getParticularInfo() {
    const apiRequest = {
      Model: {
        PriorityId: this.priorityId,
        SpecificationId: this.specificationId,
        GetActiveParticulars: this.isUpdate ? false : true
      },
    };
    this.TnCService.getTnCParticulars(
      apiRequest,
      this.callbackMethodForGetAllParticularName.bind(this)
    );
  }

  callbackMethodForGetAllParticularName(response) {
    this.courseTitle = [];
    for (let item of response.Result) {
      this.courseTitle.push({
        value: item.ParticularId, label: item.ParticularName
      });
    }
    this.particularResults = response.Result;
  };

  getTnCConfiguration() {
    this.TnCService.getTnCConfiguration(
      null,
      this.callbackMethodForGetTnCConfiguration.bind(this)
    );

  }
  callbackMethodForGetTnCConfiguration(response) {
    response.Result.CourseMode.forEach(element => {
      this.courseMode.push({
        value: element.ModeId, label: element.ModeName
      });
    });

    response.Result.CoursePriority.forEach(element => {
      this.coursePriority.push({
        value: element.PriorityId, label: element.PriorityName
      });
    });
    response.Result.CourseSpecification.forEach(element => {
      this.courseSpecification.push({
        value: element.SpecificationId, label: element.SpecificationName
      });
    });
    response.Result.InstructionLanguage.forEach(element => {
      this.courseMedium.push({
        value: element.LanguageId, label: element.LanguageName
      });
    });
  }
  
  onInputFilesUpdated(file) {
    this.TrainingCertificateFiles = file;
    this.invalidCertificate = true;
  }

  
  navigateToOverview() {
    this.router.navigate([TncConstantsService.RoutingURLConstant.TnCOverview]);
  }

   trackDetails() {
    const apiRequest = {
      Model: {
        "CourseId": this.courseId,
        "UnitId": this.TNCForm.get('TraineeName').value.UnitId,
        "UserId": this.TNCForm.get('TraineeName').value.UserId,
        "CourseStatus": this.isUpdate ? this.courseStatus : CourseStatus.Inprogress,  //CourseStatusName='Inprogress'
        "AssignedBy": this.UserId,
        "Particular": this.TNCForm.value.Title,
        "CourseMode": this.TNCForm.value.Mode,
        "Priority": this.TNCForm.value.Priority,
        "Instructionlanguage": this.TNCForm.value.MediumOfInstruction ? this.TNCForm.value.MediumOfInstruction : [0],
        "CourseSpecification": this.TNCForm.value.Specification,
        "CourseFromDate": this.TNCForm.value.FromDate,
        "CourseToDate": this.TNCForm.value.ToDate,
        "FacultyName": this.TNCForm.value.FacultyName,
        "FacultyEmail": this.TNCForm.value.FacultyEmail,
        "ModifiedBy": this.UserId,
        "StatusRemark": this.TNCForm.value.StatusRemark,
        "CompletionDate": this.TNCForm.value.CompletionDate,
        "Certificate": this.TrainingCertificateFiles,
        //"IsDraft":false,
      "StatusName": this.TNCForm.value.TrainingStatus,
       "ModeName":this.courseMode.find(x=>x.value == this.TNCForm.value.Mode).label,
       "SpecificationName":this.courseSpecification.find(x=>x.value == this.TNCForm.value.Specification).label,
       "CourseTitle":this.courseTitle.find(x=>x.value == this.TNCForm.value.Title).label
     
       
     
      },
    };
    if (!this.courseId) {
      this.isNew = true;
      this.updateSourceActionData = null;
    } 
    else {
      this.updateSourceActionData = JSON.parse(
        this.TnCService.getSourceActionData()
      );
    }
    this.oldTNCTrainingStatus = JSON.parse(
      this.TnCService.getTNCTrainingStatus()
    );
    const columnNames = Object.getOwnPropertyNames(
      this.tncRequest
    );
    columnNames.forEach(element => {
      if (this.updateSourceActionData === null) 
      {
        this.retVal = false;
      } else 
      {
        if( element == "InstructionLanguage"){
          this.retVal = this.commonService.isDataEqual(
            this.updateSourceActionData[element],
            apiRequest.Model.Instructionlanguage
          );
        }
        else if (element == "ApprovalDetails")
        {
          this.retVal = true;
        }
        else{
        this.retVal = this.commonService.isDataEqual(
          this.updateSourceActionData[element],
          apiRequest.Model[element]
        );
        }
      }
      if (this.retVal === false) 
      {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
       if (element === "ModeName") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
   
    else  if (element === "Priority") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
     

      if (element === "InstructionLanguage") {
   
        this.courseMedium.forEach((observe) => {
          apiRequest.Model.Instructionlanguage.forEach((observeid) => {
            if (observe.value === observeid) {
              userLoginActivity.NewValue +=  observe.label + ",";
            }
          });
          if (this.updateSourceActionData) {
            this.updateSourceActionData[element].forEach((observeid) => {
              if (observe.value === observeid) {
      
                userLoginActivity.OldValue +=  observe.label + ",";
              }
            });
          } else {
            userLoginActivity.OldValue = null;
          }
        });
        if(userLoginActivity.OldValue != userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      }
      
    else  if (element === "SpecificationName") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
    else  if (element === "CourseTitle") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
      else if (element === "StatusRemark") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
    // else  if (element === "CreatedBy") {
        
    //     userLoginActivity.OldValue = this.isNew
    //       ? null
    //       : this.updateSourceActionData[element];
        
    //     userLoginActivity.NewValue = apiRequest.Model[element];
    //     this.userActivityList.push(userLoginActivity);
    //   }
    //  else if (element === "ModifiedBy") {
        
    //     userLoginActivity.OldValue = this.isNew
    //       ? null
    //       : this.updateSourceActionData[element];
        
    //     userLoginActivity.NewValue = apiRequest.Model[element];
    //     this.userActivityList.push(userLoginActivity);
    //   }
     else if (element === "CompletionDate") {
        
        userLoginActivity.OldValue = (this.updateSourceActionData[element] != undefined && this.updateSourceActionData[element] != null && this.updateSourceActionData[element] != "") ? this.getFormattedDate(moment(moment.utc(this.updateSourceActionData[element]).local()).toDate()) : "";   
        userLoginActivity.NewValue = (apiRequest.Model[element] != undefined && apiRequest.Model[element] != null && apiRequest.Model[element] != "") ? this.getFormattedDate(moment(moment.utc(apiRequest.Model[element]).local()).toDate()) : "";  
        this.userActivityList.push(userLoginActivity);
      }
     else if (element === "Certificate") {
      

              // for (var i = 0; i < apiRequest.Model[element].length; i++) {
              //   if (this.updateSourceActionData[element].length !== 0) {
              //     this.updateSourceActionData[element].forEach(element => {
              //       this.url = element.Name;
              //     });
              //     userLoginActivity.OldValue += this.url + ",";
              //   } else {
              //     userLoginActivity.OldValue = null;
              //   }
              // }
              // for (var i = 0; i < apiRequest.Model[element].length; i++) {
              //   apiRequest.Model[element].forEach(element => {
              //     this.url1 = element.Name;
              //   });
              //   userLoginActivity.NewValue += this.url1 + ",";
              // }
              // if(this.url != this.url1){
              // this.userActivityList.push(userLoginActivity);
              // }
              let CertificateFilePath = "";
              let CertificateUrl = "";
              if(this.updateSourceActionData[element] != null && this.updateSourceActionData[element] != undefined && this.updateSourceActionData[element].length > 0)
              {
              for (var i = 0; i < this.updateSourceActionData[element].length; i++) {
                  this.url = this.updateSourceActionData[element][i].Name;
                  CertificateUrl = this.updateSourceActionData[element][i].FilePath;             
                  userLoginActivity.OldValue += this.url + ",";
                  CertificateFilePath += CertificateUrl + ",";
               }
              }
              else
              {
                userLoginActivity.OldValue = "";
              }
              if(apiRequest.Model[element] != null && apiRequest.Model[element] != undefined && apiRequest.Model[element].length > 0)
              {
               for (var i = 0; i < apiRequest.Model[element].length; i++) {
                  this.url1 = apiRequest.Model[element][i].Name;
                  userLoginActivity.NewValue += this.url1 + ",";
               }
              }
              else
              {
                userLoginActivity.NewValue = "";
              }
              if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
              {
                userLoginActivity.OldValue = CertificateFilePath;
                this.userActivityList.push(userLoginActivity);
              }
            }
     else if (element === "FacultyName") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
     else if (element === "FacultyEmail") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequest.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
      else if (element === "FromDate") {
        userLoginActivity.FieldName = "Planned From Date";
        userLoginActivity.OldValue = (this.updateSourceActionData[element] != undefined && this.updateSourceActionData[element] != null && this.updateSourceActionData[element] != "") ? this.getFormattedDate(moment(moment.utc(this.updateSourceActionData[element]).local()).toDate()) : "";         
        userLoginActivity.NewValue = (apiRequest.Model.CourseFromDate != undefined && apiRequest.Model.CourseFromDate != null && apiRequest.Model.CourseFromDate != "") ? this.getFormattedDate(moment(moment.utc(apiRequest.Model.CourseFromDate).local()).toDate()) : "";  
        this.userActivityList.push(userLoginActivity);
      }
      else if (element === "ToDate") {
        userLoginActivity.FieldName = "Planned To Date";
        userLoginActivity.OldValue = (this.updateSourceActionData[element] != undefined && this.updateSourceActionData[element] != null && this.updateSourceActionData[element] != "") ? this.getFormattedDate(moment(moment.utc(this.updateSourceActionData[element]).local()).toDate()) : "";  
        userLoginActivity.NewValue = (apiRequest.Model.CourseToDate != undefined && apiRequest.Model.CourseToDate != null && apiRequest.Model.CourseToDate != "") ? this.getFormattedDate(moment(moment.utc(apiRequest.Model.CourseToDate).local()).toDate()) : ""; 
        this.userActivityList.push(userLoginActivity);
      }
      // else if (element === "StatusName") {
      //   userLoginActivity.FieldName = "TrainingStatus";
      //   userLoginActivity.OldValue = this.isNew
      //     ? null
      //     : this.updateSourceActionData[element];
        
      //   userLoginActivity.NewValue = apiRequest.Model[element];
      //   this.userActivityList.push(userLoginActivity);
      // }     
    }
  });
  const userLoginActivity1 = new UserLogInActivity();
  userLoginActivity1.FieldName = "TrainingStatus";
  userLoginActivity1.OldValue = this.oldTNCTrainingStatus;
  userLoginActivity1.NewValue = this.TNCForm.value.TrainingStatus;
  if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
  {
  this.userActivityList.push(userLoginActivity1);
  }

  if (this.userActivityList.length > 0) {
    this.commonService.saveUserActivityDetails(
      this.isNew
        ? this.courseId
        : this.tncRequest.CourseId,
      new Date(),
      "TC",
      this.loggedInUserJSON.UserId,
      this.userActivityList
    );
  }
}

trackTrainingStatusDetails(OldValue,NewValue,oldTNCStatus)
{
  const userLoginActivity1 = new UserLogInActivity();
  userLoginActivity1.FieldName = "StatusRemark";
  userLoginActivity1.OldValue = OldValue["StatusRemark"];
  userLoginActivity1.NewValue = NewValue.Model["StatusRemark"];
  if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
  {
  this.userActivityListForTrainingStatus.push(userLoginActivity1);
  }

  const userLoginActivity2 = new UserLogInActivity();
  userLoginActivity2.FieldName = "CompletionDate";
  userLoginActivity2.OldValue = (OldValue["CompletionDate"] != undefined && OldValue["CompletionDate"] != null && OldValue["CompletionDate"] != "") ? this.getFormattedDate(moment(moment.utc(OldValue["CompletionDate"]).local()).toDate()) : "";  
  userLoginActivity2.NewValue = (NewValue.Model["CompletionDate"] != undefined && NewValue.Model["CompletionDate"] != null && NewValue.Model["CompletionDate"] != "") ? this.getFormattedDate(moment(moment.utc(NewValue.Model["CompletionDate"]).local()).toDate()) : ""; 
  if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
  {
  this.userActivityListForTrainingStatus.push(userLoginActivity2);
  }

  const userLoginActivity3 = new UserLogInActivity();
  userLoginActivity3.FieldName = "Certificate";
    
  let CertificateFilePath = "";
  let CertificateUrl = "";
  if(OldValue["Certificate"] != null && OldValue["Certificate"] != undefined && OldValue["Certificate"].length > 0)
  {
  for (var i = 0; i < OldValue["Certificate"].length; i++) {
      this.url = OldValue["Certificate"][i].Name;
      CertificateUrl = OldValue["Certificate"][i].FilePath;             
      userLoginActivity3.OldValue += this.url + ",";
      CertificateFilePath += CertificateUrl + ",";
    }
  }
  else
  {
    userLoginActivity3.OldValue = "";
  }
  if(NewValue.Model["Certificate"] != null && NewValue.Model["Certificate"] != undefined && NewValue.Model["Certificate"].length > 0)
  {
    for (var i = 0; i < NewValue.Model["Certificate"].length; i++) {
      this.url1 = NewValue.Model["Certificate"][i].Name;
      userLoginActivity3.NewValue += this.url1 + ",";
    }
  }
  else
  {
    userLoginActivity3.NewValue = "";
  }
  if( userLoginActivity3.OldValue!=userLoginActivity3.NewValue)
  {
    userLoginActivity3.OldValue = CertificateFilePath;
    this.userActivityListForTrainingStatus.push(userLoginActivity3);
  }

  const userLoginActivity4 = new UserLogInActivity();
  userLoginActivity4.FieldName = "TrainingStatus";
  userLoginActivity4.OldValue = oldTNCStatus;
  userLoginActivity4.NewValue = NewValue.Model["TrainingStatus"];
  if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
  {
  this.userActivityListForTrainingStatus.push(userLoginActivity4);
  }

  if (this.userActivityListForTrainingStatus.length > 0) {
    this.commonService.saveUserActivityDetails(
      this.isNew
        ? this.courseId
        : this.tncRequest.CourseId,
      new Date(),
      "TC",
      this.loggedInUserJSON.UserId,
      this.userActivityListForTrainingStatus
    );
  }
}

trackApprovalDetails(OldValue,NewValue)
{
  if(NewValue.IsApproved)
  {
  const userLoginActivity1 = new UserLogInActivity();
  userLoginActivity1.FieldName = "Expiry Date";
  userLoginActivity1.OldValue = OldValue.Model.ApprovedExpiryDate;
  userLoginActivity1.NewValue = (NewValue.ExpiryDate != undefined && NewValue.ExpiryDate != null && NewValue.ExpiryDate != "") ? this.getFormattedDate(moment(moment.utc(NewValue.ExpiryDate).local()).toDate()) : "";
  // if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
  // {
  this.userActivityListForApproval.push(userLoginActivity1);
 // }
  }
  const userLoginActivity2 = new UserLogInActivity();
  userLoginActivity2.FieldName = "Approval Remark";
  userLoginActivity2.OldValue = OldValue.Model.ApprovalRemark;
  userLoginActivity2.NewValue = NewValue.ApprovalsRemark;
  // if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
  // {
  this.userActivityListForApproval.push(userLoginActivity2);
  //}

  const userLoginActivity3 = new UserLogInActivity();
  userLoginActivity3.FieldName = "Approval Status";
  userLoginActivity3.OldValue = OldValue.Model.ApprovalStatus;
  userLoginActivity3.NewValue = NewValue.IsApproved ? "Approve": "Reject";
  // if(userLoginActivity3.OldValue != userLoginActivity3.NewValue)
  // {
  this.userActivityListForApproval.push(userLoginActivity3);
 // }

  const userLoginActivity4 = new UserLogInActivity();
  userLoginActivity4.FieldName = "ApprovedBy";
  userLoginActivity4.OldValue = OldValue.Model.ApprovedBy;
  userLoginActivity4.NewValue = NewValue.ApprovedBy;
  // if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
  // {
  this.userActivityListForApproval.push(userLoginActivity4);
  //}

  if (this.userActivityListForApproval.length > 0) {
    this.commonService.saveUserActivityDetails(
      this.isNew
        ? this.courseId
        : this.tncRequest.CourseId,
      new Date(),
      "TC",
      this.loggedInUserJSON.UserId,
      this.userActivityListForApproval
    );
  }
}

  submitTrainingStatus() {
    this.baseService.showRootLoader = true;
    if (!this.TNCForm.get('TrainingStatus').hasError('required') && this.trainingStatus == TrainingsStatus.Complete && !this.TNCForm.get('CompletionDate').hasError('required')) {
      this.isStatusDetailsValid = true;
    }
    else if (!this.TNCForm.get('StatusRemark').hasError('required')) {
      this.isStatusDetailsValid = true;
    }


    if (this.isStatusDetailsValid) {
      const apiRequest = {
        Model: {
          "CourseId": this.courseId,
          "StatusRemark": this.TNCForm.value.StatusRemark,
          "CompletionDate": this.TNCForm.value.CompletionDate,
          "Certificate": this.TrainingCertificateFiles,
          "CreatedBy": this.SelectedTrainee,
          "CourseStatus": this.courseStatus == CourseStatus.Rejected ? CourseStatus.PendingForApproval : this.courseStatus,
          "TrainingStatus" : this.TNCForm.value.TrainingStatus
        }
      };
      let oldTNCData = JSON.parse(
        this.TnCService.getSourceActionData()
      );
      let oldTNCStatus = JSON.parse(
        this.TnCService.getTNCTrainingStatus()
      );
      this.trackTrainingStatusDetails(oldTNCData,apiRequest,oldTNCStatus);
      this.TnCService.saveTnCStatus(apiRequest, this.callbackMethodForSaveTNCStatus.bind(this));
    }
  }


  callbackMethodForSaveTNCStatus(response) {
    if (response && response.Success) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "TNC Status Request Updated successfully"
      );

      window.location.reload();
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!"
      );
      this.hseErrorHandler.handleError(response.Errors);
    }
    this.baseService.showRootLoader = false;

  }


  saveApprovals(approval) {
    this.baseService.showRootLoader = true;
    if (approval == true && this.validity !== "Lifetime" && this.TNCForm.get('ExpiryDate').value == '') {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Please Add Expiry Date for Approval"
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError("Please Add Correct Date and time for Approval");
    }
    else {
      let tncApprovals = new TNCApprovals();
      tncApprovals.CourseId = this.courseId;
      tncApprovals.ApprovedBy = this.loggedInUserJSON.UserId;
      tncApprovals.IsApproved = approval;
      tncApprovals.ApprovalsRemark = this.TNCForm.value.ApprovalRemark;
      if (this.validity == 'Lifetime') {
        tncApprovals.ExpiryDate = null;
      }
      else {
        tncApprovals.ExpiryDate = this.TNCForm.value.ExpiryDate;
        //tncApprovals.ExpiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + parseInt(this.validity)));//this.TNCForm.value.ExpiryDate;
      }

      if (approval == false) {
        if (this.TNCForm.value.ApprovalRemark == "") {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Please add Remark for Reject"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Please add Remark for Reject");
        }
        if (this.TrainingCertificateFiles?.length == 0) {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Kindly Upload Certificate"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Kindly Upload Certificate");
        }
      }
      let TNCApprovalDetails = JSON.parse(
        this.TnCService.getTNCApprovalDetails()
      );
      this.trackApprovalDetails(TNCApprovalDetails,tncApprovals);
      this.TnCService.saveTnCApprovals({ Model: tncApprovals }, this.callbackMethodForSaveApprovals.bind(this));
    }
  }

  callbackMethodForSaveApprovals(response) {
    if (response.Success) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "TNC Approval Updated successfully"
      );
      this.baseService.showRootLoader = false;
      window.location.reload();
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Approval not Updated."
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError(response.Errors);
    }
  }

  async assignTraining() {
    this.baseService.showRootLoader = true;
    this.isTrainingDuplicated = false;
    if (!this.TNCForm.get('TraineeName').hasError('required') && !this.TNCForm.get('BaseUnit').hasError('required') && !this.TNCForm.get('Designation').hasError('required') && !this.TNCForm.get('EmployeeId').hasError('required') && !this.TNCForm.get('ImmediateSupervisor').hasError('required') && !this.TNCForm.get('Mode').hasError('required') && !this.TNCForm.get('MediumOfInstruction').hasError('required') && !this.TNCForm.get('Priority').hasError('required') && !this.TNCForm.get('Specification').hasError('required') && !this.TNCForm.get('Title').hasError('required') && !this.TNCForm.get('FromDate').hasError('required') && !this.TNCForm.get('ToDate').hasError('required')) {
      this.isCourseDetailsValid = true;
    }

    if (this.isCourseDetailsValid) {
      if(this.courseId == 0)
      {
      this.checkDuplicateTraining(this.TNCForm.get('TraineeName').value.UnitId,this.TNCForm.get('TraineeName').value.UserId,this.TNCForm.value.Title)
      await new Promise(f => setTimeout(f, 2000));
      if(this.isTrainingDuplicated)
      {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "The selected Training already exists for the assigned Trainee!"
        );
        this.baseService.showRootLoader = false;
        return;
       }  
      }
      const apiRequest = {
        Model: {
          "CourseId": this.courseId,
          "UnitId": this.TNCForm.get('TraineeName').value.UnitId,
          "UserId": this.TNCForm.get('TraineeName').value.UserId,
          "CourseStatus": this.isUpdate ? this.courseStatus : CourseStatus.Inprogress,  //CourseStatusName='Inprogress'
          "AssignedBy": this.UserId,
          "Particular": this.TNCForm.value.Title,
          "CourseMode": this.TNCForm.value.Mode,
          "Priority": this.TNCForm.value.Priority,
          "Instructionlanguage": this.TNCForm.value.MediumOfInstruction ? this.TNCForm.value.MediumOfInstruction : [0],
          "CourseSpecification": this.TNCForm.value.Specification,
          "CourseFromDate": this.TNCForm.value.FromDate,
          "CourseToDate": this.TNCForm.value.ToDate,
          "FacultyName": this.TNCForm.value.FacultyName,
          "FacultyEmail": this.TNCForm.value.FacultyEmail,
          "ModifiedBy": this.UserId,
          "StatusRemark": this.TNCForm.value.StatusRemark,
          "CompletionDate": this.TNCForm.value.CompletionDate,
          "Certificate": this.TrainingCertificateFiles,
          "IsDraft":false
        },
      };
      this.TnCService.saveTnCRequest(apiRequest, this.callbackMethodForSaveTNCRequests.bind(this));
    }
  }

  callbackMethodForSaveTNCRequests(response) {
    if (response && response.Success) {
      if (this.isUpdate) {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "TNC Request Updated successfully"
        );
        this.trackDetails();
      }
      else {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "TNC Request submitted successfully"
        );
      }
      this.router.navigate(["tnc/tnc-overview"]);
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!"
      );
    }
    this.baseService.showRootLoader = false;
    //this.trackDetails();
  }

  getPermissions(unitId) {
    let userPermissionParams: UserPermissionParameters = new UserPermissionParameters();
    userPermissionParams.UserId = this.loggedInUserJSON.UserId;
    userPermissionParams.ModuleId =
      ConstantsService.PermissionMatrixModules.TNC;
    userPermissionParams.UnitId = unitId;
    const apiRequest = {
      Model: userPermissionParams,
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForUserPermissions.bind(this)
    );
  }

  callbackMethodForUserPermissions(response) {
    if (response.Success) {

      this.permissions = new TNCPermission();
      this.permissions = response.Result.TNCPermission;

      if (!this.permissions.TNC_Add && !this.permissions.TNC_Add_Unit && !this.permissions.TNC_Admin && !this.permissions.TNC_Admin_Unit) {
        this.routesFlag.find(s => s.routeName == "Assign Training/Certification").isClickable = false;
      }
    }
    this.getReportiesByManagerId();
  }

  getReportiesByManagerId() {
    const apiRequest = {
      Model: { UserId: this.loggedInUserJSON.UserId },
    };
    this.TnCService.getReportiesByManagerId(
      apiRequest,
      this.callbackMethodForGetReporties.bind(this)
    );
  }

  callbackMethodForGetReporties(response) {
    if (response.Result)
      this.reporties = response.Result;
  }

  downloadFile(url) {
    saveAs(url);
  }
  selectFile(fileUrl) {
    this.currentFileUrl = fileUrl;
  }

  enableSaveStatusButton(event) {
    if (event.value) {
      this.isStatusModified = true;
    }
  }
  ChangeExpiry()
  {
    if(this.validity != 'Lifetime')
    {
      if(this.validity != "As per certificate")
      {
      if(this.TNCForm.get("CompletionDate").value != "" )
      {
        let CompDate = new Date(this.TNCForm.get("CompletionDate").value);
        this.TNCForm.patchValue({
          ExpiryDate: moment(moment.utc(new Date(CompDate.setFullYear(CompDate.getFullYear() + parseInt(this.validity)))).local()).toDate() 
        });
      }
      }
      else
      {
        this.TNCForm.patchValue({ ExpiryDate: '' });
      }
    }
  }
  selectTrainingStatus(event, status) {
    this.isStatusModified = true;
    if (event) {
      switch (status) {
        case 'Complete':
          this.trainingStatus = TrainingsStatus.Complete;
          this.courseStatus = CourseStatus.PendingForApproval;
          break;
        case 'Not Complete':
          this.trainingStatus = TrainingsStatus.NotComplete;
          this.courseStatus = CourseStatus.NotComplete;
          break;
        case 'Cancel':
          this.trainingStatus = TrainingsStatus.Cancel;
          this.courseStatus = CourseStatus.Cancel;
          break;
        case 'Delete':
          this.trainingStatus = TrainingsStatus.Delete;
          this.courseStatus = CourseStatus.Delete;
          break;
      }
      if (this.trainingStatus != TrainingsStatus.Complete) {
        this.TNCForm.patchValue({ CompletionDate: '' });
      }
      else
        this.TNCForm.patchValue({ StatusRemark: '' });

    }
  }

  onPreviousClick() {
    this.courseIndex = -1;
    this.isNext = true;
    this.disableCourse = false;
    this.courseIds = this.TnCService.getAllTnCRequestIds();
    if (this.courseIds) {
      this.courseIds.forEach((element, index) => {
        if (element.CourseId === this.courseId && index - 1 != null) {
          this.courseIndex = index - 1;
          if (this.courseIndex <= 0) {
            this.isPrevious = false;
          } else {
            this.isPrevious = true;
          }
          return;
        }
      });
    }
    if (this.courseIndex > -1) {
      this.courseId = this.courseIds[
        this.courseIndex
      ].CourseId;
      this.unitId = this.courseIds[this.courseIndex].UnitId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          CourseId: this.courseId,
        },
      };
      this.TnCService.getTNCRequestByCourseId(
        apiRequest,
        this.callbackMethodForGetTNCRequestByCourseId.bind(this)
      );
      this.router.navigate(
        ['/tnc/assign-training/', this.courseId], { queryParams: { unitId: this.unitId } }
      );
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.courseIndex = -1;
    this.disableCourse = false;
    this.courseIds = this.TnCService.getAllTnCRequestIds();
    if (this.courseIds) {
      this.courseIds.forEach((element, index) => {
        if (element.CourseId === this.courseId && index + 1 != null) {
          this.courseIndex = index + 1;
          if (this.courseIndex + 1 == this.courseIds.length) {
            this.isNext = false;
          } else {
            this.isNext = true;
          }
          return;
        }
      });
    }
    if (this.courseIndex > -1) {
      this.courseId = this.courseIds[
        this.courseIndex
      ].CourseId;
      this.unitId = this.courseIds[this.courseIndex].UnitId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          CourseId: this.courseId,
        },
      };
      this.TnCService.getTNCRequestByCourseId(
        apiRequest,
        this.callbackMethodForGetTNCRequestByCourseId.bind(this)
      );
      this.router.navigate(
        ['/tnc/assign-training/', this.courseId], { queryParams: { unitId: this.unitId } }
      );
    }
  }

  toUserProfile() {
    if (this.isUpdate)
      this.router.navigate(['/tnc/user-profile', this.SelectedTrainee]);
  }

  ngOnInit(): void {

    this.TNCForm = this.formBuilder.group({
      TraineeName: new FormControl('', Validators.required),
      BaseUnit: new FormControl({ value: '', disabled: true }, Validators.required),
      Designation: new FormControl({ value: '', disabled: true }, Validators.required),
      ContractNumber: new FormControl({ value: '', disabled: true }),
      EmployeeId: new FormControl({ value: '', disabled: true }, Validators.required),
      ImmediateSupervisor: new FormControl({ value: '', disabled: true }, Validators.required),
      Mode: new FormControl('', Validators.required),
      MediumOfInstruction: new FormControl('', Validators.required),
      Priority: new FormControl('', Validators.required),
      Specification: new FormControl('', Validators.required),
      Title: new FormControl('', Validators.required),
      FromDate: new FormControl('', Validators.required),
      ToDate: new FormControl('', Validators.required),
      FacultyName: new FormControl(''),
      FacultyEmail: new FormControl('', Validators.email),
      TrainingStatus: new FormControl('', Validators.required),
      StatusRemark: new FormControl('', Validators.required),
      CompletionDate: new FormControl('', Validators.required),
      ExpiryDate: new FormControl('', Validators.required),
      btnApprove: new FormControl("Approve"),
      btnReject: new FormControl("Reject"),
      ApprovalRemark: new FormControl('')
    });

    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    
    this.isUpdate = false;
    this.getPermissions(this.loggedInUserJSON.UnitId);

    this.UserId = this.loggedInUserJSON.UserId;
    this.sub = this.route.params.subscribe((params) => {
      this.courseId = coerceNumberProperty(params["tncId"])
      this.unitId = coerceNumberProperty(params["unitId"]);
    });
    if (this.courseId !== 0 && this.courseId) {
      this.display = false;
    }
    this.getPermissionDetails(this.unitId);
  }

  setUsersData() {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsers.bind(this));
  }
  callbackMethodForGetSearchResultsForUsers(response) {
    if (response.Success) {
      this.allUsers = response.Result;
      this.allUsersData = [];
      this.allUsers.forEach(s =>
        this.allUsersData.push({
          label: s.FullName,
          value: s.UserId
        })
      );
      this.checkIsUpdateProcess();
    }
  }

  getAllUsers(){
    this.masterscreenService.getUserDetails(
      null,
      this.callbackMethodForGetUserDetails.bind(this)
    );
  }
  callbackMethodForGetUserDetails(response) {
    if (response && response.Result) {
      this.allUsers = response.Result;
      this.allUsersData = [];
      this.allUsers.forEach(s =>
        this.allUsersData.push({
          label: s.FullName,
          value: s.UserId
        })
      );
      this.checkIsUpdateProcess();
    }
  }

  ResetForm() {
    this.dialogType = "ConfirmReset";
    this.alertType = "Confirm";
    this.successDetails = null;
    this.errorDetails = null;
    this.confirmMessage = "You have clicked reset button. All information entered by you on this page will be lost. Do you want to reset the form?";
  }
  checkIsUpdateProcess() {
    if (this.courseId !== 0 && this.courseId) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          "CourseId": this.courseId
        }
      };
      this.TnCService.getTNCRequestByCourseId(apiRequest, this.callbackMethodForGetTNCRequestByCourseId.bind(this))
    }
  }

  callbackMethodForGetTNCRequestByCourseId(response) {
    if (response.Result) {
    //   if (this.loggedInUserJSON.UserTypes.UserType ===
    //     ObservationConstantsService.RequestFor.Contractor && response.Result.AssignedBy != this.loggedInUserJSON.UserId
    //  ) {
    //    this.notificationsService.toastNotify(
    //      "error",
    //      "Warning Message",
    //      "This Training and Certification not raised by you, you don't have permission to view this record...!"
    //    );   
    //    this.router.navigate(["tnc/tnc-overview"]);
    //    return ; 
    //  }
      this.tncRequest = response.Result;
      this.isUpdate = true;
      this.courseStatus = response.Result.CourseStatus;
      this.SelectedTrainee = response.Result.UserId;
      if (this.allUsers && this.allUsers.length) {
        this.user = this.allUsers.find(u => u.UserId == this.SelectedTrainee);
        if (this.user) {
          this.TNCForm.patchValue({ TraineeName: this.user });
          this.TNCForm.patchValue({ BaseUnit: this.user.UnitName });
          this.TNCForm.patchValue({ Designation: this.user.Designation });
          this.TNCForm.patchValue({ EmployeeId: this.user.SecondaryId });
          this.immediateSuperwiser = this.allUsers.find(u => u.UserId == this.user.ReportingTo);
          this.TNCForm.patchValue({ ImmediateSupervisor: this.immediateSuperwiser ? this.immediateSuperwiser.FullName : '' });
          this.isManager = this.reporties.includes(this.user.UserId);
        }
      }
      if (this.SelectedTrainee == this.UserId)
        this.isTrainee = true;
      this.TNCForm.patchValue({ Mode: response.Result.CourseMode });
      this.TNCForm.patchValue({ MediumOfInstruction: response.Result.InstructionLanguage });
      this.TNCForm.patchValue({ Priority: response.Result.Priority });
      this.TNCForm.patchValue({ Specification: response.Result.Specification });
      this.assignedBy = response.Result.AssignedBy;
     
      if(this.courseTitle && this.courseTitle.length > 0)
      {
        this.courseTitle.forEach(element => {
        if(element.value === response.Result.Particular)
        {
        this.count = 1;
        this.title = element.value;
        }
       });
      }

      if(this.particularResults && this.particularResults.length > 0)
      {
        this.particularResults.forEach(element => {
          if(element.ParticularId === response.Result.Particular)
          {
           this.countValidity = 1;
           this.validity = element.Validity;
           this.isCertificateRequired = element.IsCertificateRequired;  
          }
         });
      }

      // if(this.courseTitle.find(t=>t.value) == response.Result.Particular ){
      // this.title = this.courseTitle.find(t => t.value == response.Result.Particular).value;
      // this.validity = this.particularResults.find(t => t.ParticularId == response.Result.Particular).Validity;
      // this.isCertificateRequired = this.particularResults.find(t => t.ParticularId == response.Result.Particular).IsCertificateRequired;
      // }
      // else{
      if(this.count < 1)
      {  
        this.title = 0;
      }
      if(this.countValidity < 1)
      {
        this.validity=" ";
        this.isCertificateRequired= false;
      }
      //}
     
      this.TNCForm.patchValue({ Title: this.title });
      this.TNCForm.patchValue({ FromDate: moment(moment.utc(response.Result.FromDate).local()).toDate() });
      this.TNCForm.patchValue({ ToDate: moment(moment.utc(response.Result.ToDate).local()).toDate() });
      this.TNCForm.patchValue({ FacultyName: response.Result.FacultyName });
      this.TNCForm.patchValue({ FacultyEmail: response.Result.FacultyEmail });
      if (response.Result.CourseStatus) {
        switch (response.Result.CourseStatus) {
          case CourseStatus.Inprogress:
            this.courseStatus = CourseStatus.Inprogress;
            break;
          case CourseStatus.PendingForApproval:
            this.courseStatus = CourseStatus.PendingForApproval;
            this.trainingStatus = TrainingsStatus.Complete;
            this.statusName = 'Complete';
            this.isStatusModified = true;
            this.TNCForm.patchValue({ CompletionDate: response.Result.CompletionDate ? moment(moment.utc(response.Result.CompletionDate).local()).toDate() : '' });
            if(this.validity != 'Lifetime')
            {
              if(this.validity != "As per certificate" && this.TNCForm.get("CompletionDate").value != "")
              {       
                let CompDate = new Date(this.TNCForm.get("CompletionDate").value);
                this.TNCForm.patchValue({
                  ExpiryDate: moment(moment.utc(new Date(CompDate.setFullYear(CompDate.getFullYear() + parseInt(this.validity)))).local()).toDate() 
                });
              }
              else
              {
                this.TNCForm.patchValue({ ExpiryDate: '' });
              }
            }
            break;
          case CourseStatus.NotComplete:
            this.courseStatus = CourseStatus.NotComplete;
            this.trainingStatus = TrainingsStatus.NotComplete;
            this.statusName = 'Not Complete';
            break;
          case CourseStatus.Cancel:
            this.courseStatus = CourseStatus.Cancel;
            this.trainingStatus = TrainingsStatus.Cancel;
            this.statusName = 'Cancel';
            break;
          case CourseStatus.Delete:
            this.courseStatus = CourseStatus.Delete;
            this.trainingStatus = TrainingsStatus.Delete;
            this.statusName = 'Delete';
            break;
          case CourseStatus.Rejected:
            this.courseStatus = CourseStatus.Rejected;
            this.trainingStatus = TrainingsStatus.Complete;
            this.statusName = 'Complete';
            this.isStatusModified = true;
            this.TNCForm.patchValue({ CompletionDate: response.Result.CompletionDate ? moment(moment.utc(response.Result.CompletionDate).local()).toDate() : '' });
            if(this.validity != 'Lifetime')
            {
              if(this.validity != "As per certificate" && this.TNCForm.get("CompletionDate").value != "")
              {
                let CompDate = new Date(this.TNCForm.get("CompletionDate").value);
                this.TNCForm.patchValue({
                  ExpiryDate: moment(moment.utc(new Date(CompDate.setFullYear(CompDate.getFullYear() + parseInt(this.validity)))).local()).toDate() 
                });
              }
              else
              {
                this.TNCForm.patchValue({ ExpiryDate: '' });
              }
            }
            break;
          case CourseStatus.Complete:
            this.courseStatus = CourseStatus.Complete;
            this.trainingStatus = TrainingsStatus.Complete;
            this.statusName = 'Complete';
            this.isStatusModified = true;
            break;

        }
      }
      this.TNCForm.patchValue({ TrainingStatus: this.statusName });
      this.TNCForm.patchValue({ StatusRemark: response.Result.StatusRemark });
      this.TNCForm.patchValue({ CompletionDate: response.Result.CompletionDate ? moment(moment.utc(response.Result.CompletionDate).local()).toDate() : '' });

      if(this.validity != "Lifetime"){
        this.maxExpiryDate = new Date(this.TNCForm.get("CompletionDate").value);
        this.maxExpiryDate.setFullYear(this.maxExpiryDate.getFullYear() + parseInt(this.validity));
      }else{
        this.maxExpiryDate = new Date(this.TNCForm.get("CompletionDate").value);
        this.maxExpiryDate.setFullYear(this.maxExpiryDate.getFullYear() + 100);
      }

      if (response.Result.Certificate) {
        if (response.Result.Certificate.length) {
          this.TrainingCertificateFiles = response.Result.Certificate;
          this.PreviewUrl = response.Result.Certificate[0].SourceUrl;
          this.FileName = response.Result.Certificate[0].Name;
        }
      }
      this.invalidCertificate = response.Result.Certificate ? true : false;

      this.TNCForm.get("TraineeName").disable();
      if(!this.permissions.TNC_Admin && !this.permissions.TNC_Admin_Unit ){
        this.TNCForm.get("Mode").disable();
        this.TNCForm.get("MediumOfInstruction").disable();
        this.TNCForm.get("Priority").disable();
        this.TNCForm.get("Specification").disable();
        this.TNCForm.get("Title").disable();
        this.TNCForm.get("FromDate").disable();
        this.TNCForm.get("ToDate").disable();
        this.TNCForm.get("FacultyName").disable();
        this.TNCForm.get("FacultyEmail").disable();
        this.TNCForm.get('TrainingStatus').disable();
        this.TNCForm.get("btnApprove").disable();
        this.TNCForm.get("btnReject").disable();
        this.TNCForm.get("ExpiryDate").disable();
        this.TNCForm.get("StatusRemark").disable();
        this.TNCForm.get("CompletionDate").disable();
      }



      if ((this.courseStatus == CourseStatus.Draft || this.courseStatus == CourseStatus.Inprogress) && (this.isManager || this.permissions.TNC_Admin || this.permissions.TNC_Admin_Unit)) {
        this.TNCForm.get("Mode").enable();
        this.TNCForm.get("MediumOfInstruction").enable();
        this.TNCForm.get("Priority").enable();
        this.TNCForm.get("Specification").enable();
        this.TNCForm.get("Title").enable();
        this.TNCForm.get("FromDate").enable();
        this.TNCForm.get("ToDate").enable();
        this.TNCForm.get("FacultyName").enable();
        this.TNCForm.get("FacultyEmail").enable();
      }

      if ((this.isTrainee && (this.courseStatus == CourseStatus.Draft || this.courseStatus == CourseStatus.Inprogress || this.courseStatus == CourseStatus.TrainingRescheduled || this.courseStatus == CourseStatus.Rejected)) || this.permissions.TNC_Admin || this.permissions.TNC_Admin_Unit) {
        this.TNCForm.get('TrainingStatus').enable();
        this.TNCForm.get("StatusRemark").enable();
        this.TNCForm.get("CompletionDate").enable();
      }

      if (this.isManager || this.permissions.TNC_Admin || this.permissions.TNC_Admin_Unit) {
        if (this.courseStatus == CourseStatus.PendingForApproval) {
          this.TNCForm.get("btnApprove").enable();
          this.TNCForm.get("btnReject").enable();
          this.TNCForm.get("ExpiryDate").enable();
        }
        else if (this.courseStatus == CourseStatus.NotComplete || this.courseStatus == CourseStatus.Cancel) {
          this.TNCForm.get("FromDate").enable();
          this.TNCForm.get("ToDate").enable();
          this.TNCForm.get("ExpiryDate").disable();
        }
      }


      //Approval bindings

      if (response.Result.ApprovalDetails.length > 0) {
        this.validator = this.immediateSuperwiser ? this.immediateSuperwiser.FullName : '';
        this.validatorDesignation = this.immediateSuperwiser ? this.immediateSuperwiser.Designation : '';
        this.ApprovalDate = moment(moment.utc(response.Result.ApprovalDetails[0].ModifiedDate).local()).toDate();
        this.status = response.Result.ApprovalDetails[0].IsApproved ? 'Approved' : 'Rejected';

        if (this.courseStatus == CourseStatus.PendingForApproval && this.isManager) {
          this.TNCForm.patchValue({ ApprovalRemark: "" });
          this.TNCForm.get("btnReject").enable();
          this.TNCForm.get("btnApprove").enable();
           
        } else {
          this.TNCForm.patchValue({ ApprovalRemark: response.Result.ApprovalDetails[0].ApproverRemark ? response.Result.ApprovalDetails[0].ApproverRemark : "" });
        }
        if (response.Result.ApprovalDetails[0].ExpiryDate && response.Result.ApprovalDetails[0].IsApproved && this.courseStatus != CourseStatus.PendingForApproval && this.courseStatus != CourseStatus.Rejected) {
          this.TNCForm.patchValue({ ExpiryDate: moment(moment.utc(response.Result.ApprovalDetails[0].ExpiryDate).local()).toDate() });
        }
        if (this.courseStatus !== CourseStatus.PendingForApproval && response.Result.ApprovalDetails[0].IsApproved && (this.isManager || this.permissions.TNC_Admin || this.permissions.TNC_Admin_Unit) ) {
          this.TNCForm.get("btnApprove").disable();
        }
        else if (!response.Result.ApprovalDetails[0].IsApproved && (this.isManager || this.permissions.TNC_Admin || this.permissions.TNC_Admin_Unit) && this.courseStatus == CourseStatus.Rejected) {
          this.TNCForm.get("btnReject").disable();
        }
       
      }

      this.priorityId = this.TNCForm.value.Priority;
      this.specificationId = this.TNCForm.value.Specification;
      this.getParticularInfo();
      this.baseService.showRootLoader = false;

      if(!this.isUpdate || this.courseStatus == CourseStatus.Inprogress || this.trainingStatus != TrainingsStatus.Complete){
        this.isApprovalSectionShow = false;
      }else{
        this.isApprovalSectionShow = true;
      }
    }
    let ApprovedExpiryDate = "";
    let ApprovalRemark = "";
    let ApprovalStatus = "";
    let ApprovedBy = 0;
 
    if(response.Result.ApprovalDetails != null && response.Result.ApprovalDetails.length > 0)
    {
      ApprovalRemark = response.Result.ApprovalDetails[0].ApproverRemark ? response.Result.ApprovalDetails[0].ApproverRemark : "";
      if(response.Result.ApprovalDetails[0].ExpiryDate && response.Result.ApprovalDetails[0].IsApproved)
      {
        ApprovedExpiryDate = this.getFormattedDate(moment(moment.utc(response.Result.ApprovalDetails[0].ExpiryDate).local()).toDate());
      }
      ApprovalStatus = response.Result.ApprovalDetails[0].IsApproved ? "Approve" : "Reject";
      ApprovedBy = response.Result.ApprovalDetails[0].ApprovedBy;
    }

    const oldTNCApprovalDetails = {
      Model: {
        "ApprovedExpiryDate": ApprovedExpiryDate,
        "ApprovalRemark": ApprovalRemark,
        "ApprovalStatus" : ApprovalStatus,
        "ApprovedBy" : ApprovedBy
      },
    };
    this.TnCService.setSourceActionData(
      JSON.stringify(this.tncRequest)
    );

    this.TnCService.setTNCTrainingStatus(
      JSON.stringify((this.TNCForm.value.TrainingStatus != undefined && this.TNCForm.value.TrainingStatus != null) ? this.TNCForm.value.TrainingStatus : "")
    );

    this.TnCService.setTNCApprovalDetails(
      JSON.stringify(oldTNCApprovalDetails)
    );

    this.courseIds = this.TnCService.getAllTnCRequestIds();
    if(this.courseIds == null){
      this.isNext = false;
      this.isPrevious = false;
    }
    let currentIndex: number = 0;
    if (this.courseIds) {
      this.courseIds.forEach((element, index) => {
        if (element.CourseId === this.courseId) {
          currentIndex = index;
          return;
        }
      });
      if (currentIndex === 0) {
        this.isPrevious = false;
      }
      if (currentIndex === this.courseIds.length - 1) {
        this.isNext = false;
      }
    }

    if(this.courseStatus == CourseStatus.PendingForApproval || this.courseStatus == CourseStatus.Rejected )
    {
      if( this.TrainingCertificateFiles.length > 0)
      {
      this.TNCForm.get("btnApprove").enable();
      }else{
      this.TNCForm.get("btnApprove").disable();
      }
    }
  }

  getPermissionDetails(unitId) {
    this.userPermissions.ModuleId =
      ConstantsService.PermissionMatrixModules.TNC;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = unitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForgetPermissionDetails.bind(this)
    );
  }

  callbackMethodForgetPermissionDetails(response) {
    const permissions = response.Result;
    if (response.Result) {
      if (permissions.TNCPermission) {
        this.permissions = permissions.TNCPermission;
        this.tncPermissions = permissions.TNCPermission;
        if (this.tncRequest && (this.tncRequest.Status === CourseStatus.Cancel || this.tncRequest.Status === CourseStatus.Cancelled || this.tncRequest.Status === CourseStatus.Deleted) && (!this.tncPermissions.TNC_Admin || !this.tncPermissions.TNC_Admin_Unit)) {
          this.disableTNC = true;
        }
        else {
          this.disableTNC = false;
        }
      }
    }
    this.baseService.showRootLoader = false;
    this.getAllModules();
    this.getTnCConfiguration();
    this.getParticularInfo();
    if (this.courseId !== 0 && this.courseId){
      this.getAllUsers();
    }
    else{
      this.setUsersData();
    }
  }
  getAllModules() {
    this.masterscreenService.getAllModules(
      null,
      this.callbackMethodForGetAllModules.bind(this)
    );
  }

  callbackMethodForGetAllModules(response) {
    if (response.Success) {
      this.moduleList = response.Result;
      this.moduleList.forEach(element => {
        if (element.ModuleName === "TNC") {
          this.moduleId = element.ModuleId;
        }
      });
    }
  }

  onOkClickedForConfirmation() {
    switch (this.dialogType) {
      case "CheckDuplicatePermit":
        window.location.reload();
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }

  onYesClickedForConfirmation() {
    switch (this.dialogType) {
      case "UpdateTraining":
        this.assignTraining();
        break;
      case "ConfirmReset":
        window.location.reload();
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  onNoClickedForConfirmation() {
    switch (this.dialogType) {
      case "UpdateTraining":
        break;
      case "ConfirmReset":
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }

  reScheduleTraining() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "CourseId": this.courseId,
        "UserId": this.loggedInUserJSON.UserId,
        "PlannedDateFrom": this.TNCForm.value.FromDate,
        "PlannedDateTo": this.TNCForm.value.ToDate
      }
    };
    this.TnCService.setCourseReschedule(apiRequest, this.callbackMethodForSetCourseReschedule.bind(this))
  }

  callbackMethodForSetCourseReschedule(response) {
    if (response.Success) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Rescheduled successfully"
      );
      this.baseService.showRootLoader = false;
      window.location.reload();
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Not Rescheduled."
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError(response.Errors);
    }
  }

  getOutput(event) {
    if (event) {
      this.router.navigate(["tnc/tnc-overview"]);
    }
  }

  showDialog() {
    this.displayFile = true;
  }
  downloadPDFFile() {
    saveAs(this.PreviewUrl, this.FileName)
  }
  async saveAsDraft() {
    this.baseService.showRootLoader = true;
    this.isTrainingDuplicated = false;
    if (!this.TNCForm.get('TraineeName').hasError('required') && !this.TNCForm.get('BaseUnit').hasError('required') && !this.TNCForm.get('Designation').hasError('required') && !this.TNCForm.get('EmployeeId').hasError('required') && !this.TNCForm.get('ImmediateSupervisor').hasError('required') && !this.TNCForm.get('Mode').hasError('required') && !this.TNCForm.get('MediumOfInstruction').hasError('required') && !this.TNCForm.get('Priority').hasError('required') && !this.TNCForm.get('Specification').hasError('required') && !this.TNCForm.get('Title').hasError('required') && !this.TNCForm.get('FromDate').hasError('required') && !this.TNCForm.get('ToDate').hasError('required')) {
      this.isCourseDetailsValid = true;
    }

    if (this.isCourseDetailsValid) {
      if(this.courseId == 0)
      {
      this.checkDuplicateTraining(this.TNCForm.get('TraineeName').value.UnitId,this.TNCForm.get('TraineeName').value.UserId,this.TNCForm.value.Title)
      await new Promise(f => setTimeout(f, 2000));
      if(this.isTrainingDuplicated)
      {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "The selected Training already exists for the assigned Trainee!"
        );
        this.baseService.showRootLoader = false;
        return;
       }  
      }
      const apiRequest = {
        Model: {
          "CourseId": this.courseId,
          "UnitId": this.TNCForm.get('TraineeName').value.UnitId,
          "UserId": this.TNCForm.get('TraineeName').value.UserId,
          "CourseStatus": this.isUpdate ? this.courseStatus : CourseStatus.Inprogress,  //CourseStatusName='Inprogress'
          "AssignedBy": this.UserId,
          "Particular": this.TNCForm.value.Title,
          "CourseMode": this.TNCForm.value.Mode,
          "Priority": this.TNCForm.value.Priority,
          "Instructionlanguage": this.TNCForm.value.MediumOfInstruction ? this.TNCForm.value.MediumOfInstruction : [0],
          "CourseSpecification": this.TNCForm.value.Specification,
          "CourseFromDate": this.TNCForm.value.FromDate,
          "CourseToDate": this.TNCForm.value.ToDate,
          "FacultyName": this.TNCForm.value.FacultyName,
          "FacultyEmail": this.TNCForm.value.FacultyEmail,
          "ModifiedBy": this.UserId,
          "StatusRemark": this.TNCForm.value.StatusRemark,
          "CompletionDate": this.TNCForm.value.CompletionDate,
          "Certificate": this.TrainingCertificateFiles,
          "IsDraft":true
        },
      };
      this.TnCService.saveTnCRequest(apiRequest, this.callbackMethodForSaveTNCRequests.bind(this));
    }
  }
  //BOC Pritesh
  ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "TC";
    this.ReportRecordId = this.courseId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh

  checkDuplicateTraining(UnitId,UserId,Title)
  {
    const apiRequest = {
      Model: {
        "UnitId": UnitId,
        "UserId": UserId,
        "Particular": Title
      },
    };
    this.TnCService.checkDuplicateTraining(apiRequest, this.callbackMethodForcheckDuplicateTraining.bind(this));
  }

  callbackMethodForcheckDuplicateTraining(response) {
    if (response && response.Success) {
     this.isTrainingDuplicated = response.Result;
    } 
  }

  getFormattedDate(date)
  {
    var diffinMin=date.getTimezoneOffset()*-1;
    date.setMinutes(date.getMinutes() + diffinMin);
    var dd   = date.getUTCDate();
    var mm   = date.getUTCMonth()+1;
    var yyyy = date.getUTCFullYear();
    var hour = date.getUTCHours();
    var minu = date.getUTCMinutes();

    if(dd<10)  { dd='0'+dd } 
    if(mm<10)  { mm='0'+mm } 
    if(minu<10){ minu='0'+minu } 

    return dd +'/'+mm+'/'+yyyy;
  }

}
